<template>
  <div class="md-layout">
    <div class="md-layout-item gallery-item">
      <p>
        <strong>{{ title }}</strong>
      </p>

      <!-- Modal de seleção de produtos -->
      <div class="products-modal" v-if="type === 'product' && showProductsModal">
        <span>Escolha um produto</span>
        <md-button @click="showProductsModal = false" class="close-btn">
          <md-icon>close</md-icon>
        </md-button>
        <div class="products-modal-content">
          <ul class="grid">
            <li v-for="item in products" :key="item.uid" class="grid-item">
              <img
                :src="item.data.imagem_principal.url"
                class="grid-item-img"
                @click="showImage(item.data.imagem_principal.url)"
              />
              <div>
                <h5 class="grid__item-text">{{ item.data.nome[0].text }}</h5>
                <span class="grid__item-category">
                  Linha {{ item.data.categoria_produto.uid }}
                </span>
              </div>
              <md-button class="grid__item-button" @click="addProduct(item)">
                <md-icon>add</md-icon>
              </md-button>
            </li>
          </ul>
        </div>
      </div>

      <!-- Galeria / seleção de imagens -->
      <ul class="grid">
        <li
          v-for="item in images"
          :key="item.uid || item.url"
          class="grid-item"
        >
          <img
            :src="getItemImage(item)"
            class="grid-item-img"
            @click="showImage(getItemImage(item))"
          />
          <div v-if="type === 'product'">
            <h5 class="grid__item-text">{{ getItemText(item) }}</h5>
            <span class="grid__item-category">
              Linha {{ getItemCategory(item) }}
            </span>
          </div>
          <md-button class="grid__item-button" @click="handleImageRemove(item)">
            <md-icon>delete</md-icon>
          </md-button>
        </li>
        <li class="add-item">
          <input
            type="file"
            ref="fileInput"
            style="display: none"
            accept="image/*"
            @change="onFilePicked"
          />
          <md-button
            v-if="type === 'product'"
            @click="openModal"
            class="add-btn"
          >
            <md-icon class="add-icon">add</md-icon>
          </md-button>
          <md-button
            v-if="type === 'gallery'"
            @click="handleGallery"
            class="add-btn"
          >
            <md-icon class="add-icon">add</md-icon>
          </md-button>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import api from "@/services/api";
export default {
  name: 'ProjectGallery',
  props: {
    title: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      default: 'gallery',
    },
    value: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      images: [],
      products: [],
      showProductsModal: false,
    };
  },
  mounted() {
    if (!this.value) {
      this.images = [];
    }
  },
  watch: {
    value(val) {
      if (!val) {
        this.images = [];
      } else {
        try {
          this.images = JSON.parse(val);
        } catch (e) {
          console.warn('JSON inválido em prop value:', val);
          this.images = [];
        }
      }
    },
  },
  created() {
    if (this.type === 'product') {
      this.getContent();
    }
  },
  methods: {
    openModal() {
      this.showProductsModal = true;
    },

    addProduct(item) {
      // Monta designs e tonalidades
      const designs = item.data.designs.map(d => ({ design_produto: { uid: d.design_produto.uid } }));
      const tonalidades = item.data.tonalidades.map(t => ({ tonalidade_produto: { uid: t.tonalidade_produto.uid } }));

      // Adiciona imagem/produto
      this.images.push({
        uid: item.uid,
        data: {
          categoria_produto: { uid: item.data.categoria_produto.uid },
          nome: [{ text: item.data.nome[0].text }],
          imagem_principal: { url: item.data.imagem_principal.url },
          designs,
          tonalidades,
        },
      });

      // Remove produto da lista para não duplicar
      this.products = this.products.filter(p => p.uid !== item.uid);

      // Emite valor e fecha modal
      this.$emit('input', JSON.stringify(this.images));
      this.showProductsModal = false;
    },

    async getContent() {
      if (this.type !== 'product') return;
      try {
        const first = await this.$prismic.client.query(
          this.$prismic.Predicates.at('document.type', 'produto'),
          { pageSize: 100, page: 1 }
        );
        const totalPages = first.total_pages || 1;
        const remaining = await Promise.all(
          Array.from({ length: totalPages - 1 }, (_, i) =>
            this.$prismic.client.query(
              this.$prismic.Predicates.at('document.type', 'produto'),
              { pageSize: 100, page: i + 2 }
            )
          )
        );
        const raw = [first, ...remaining].flatMap(r => r.results);
        this.products = raw.filter(v => v.lang === 'pt-br');
      } catch (e) {
        console.error('Falha ao buscar produtos:', e);
      }
    },

    showImage(img) {
      this.$store.commit('showImage', { img });
    },

    handleGallery() {
      this.$refs.fileInput.click();
    },

    async onFilePicked(event) {
      const file = event.target.files[0];
      const formData = new FormData();
      formData.append('file[0]', file);

      try {
        const response = await api.post(`${window.api}upload/`, formData);
        this.images.push({ url: response.data.imgs[0].url });
        this.$emit('input', JSON.stringify(this.images));
      } catch (error) {
        console.error(error);
      } finally {
        this.$refs.fileInput.value = null;
      }
    },

    handleImageRemove(item) {
      const key = item.uid || item.url;
      this.images = this.images.filter(i => (i.uid || i.url) !== key);
      this.$emit('input', JSON.stringify(this.images));
    },

    getItemImage(item) {
      if (item.url) {
        return item.url;
      }
      if (item.data && item.data.imagem_principal && item.data.imagem_principal.url) {
        return item.data.imagem_principal.url;
      }
      if (
        item.node &&
        item.node.data &&
        item.node.data.imagem_principal &&
        item.node.data.imagem_principal.url
      ) {
        return item.node.data.imagem_principal.url;
      }
      return '';
    },

    getItemText(item) {
      if (this.type === 'gallery') {
        return item.url ? item.url.split('/').pop() : '';
      }
      const data = item.data || (item.node && item.node.data) || {};
      if (Array.isArray(data.nome) && data.nome.length > 0) {
        return data.nome[0].text || '';
      }
      return '';
    },

    getItemCategory(item) {
      if (this.type === 'gallery') return '';
      const data = item.data || (item.node && item.node.data) || {};
      const uid = data.categoria_produto && data.categoria_produto.uid;
      return uid ? uid.split('-').join(' ') : '';
    },
  },
};
</script>

<style scoped>
.gallery-item {
  position: relative;
}

.products-modal {
  background: #fff;
  width: 100%;
  height: 100vh;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 99999;
  padding: 20px;
  border: 1px solid #ccc;
  border-radius: 5px;
}

.close-btn {
  position: absolute;
  top: 5px;
  right: 5px;
}

.products-modal-content {
  max-height: calc(100% - 40px);
  overflow-y: auto;
  overscroll-behavior: contain;
  margin-top: 10px;
}

.grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 10px;
  padding: 0;
}

.grid-item {
  display: block;
}

.grid-item-img {
  width: 100%;
  cursor: pointer;
}

.grid__item-text {
  margin: 8px 0;
}

.grid__item-category {
  margin: 0;
}

.grid__item-button,
.add-btn {
  width: 100%;
  margin: 10px 0;
}

.add-item {
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
}

.add-icon {
  font-size: 60px !important;
}
</style>
